import React, { ReactElement } from 'react'
import { SearchBoxProvided } from 'react-instantsearch-core'

/**
 * example connecting custom component
 * @param currentRefinement
 * @param isSearchStalled
 * @param refine
 * @constructor
 */
const SearchBox = ({
  currentRefinement,
  isSearchStalled,
  refine,
}: SearchBoxProvided): ReactElement => {
  return (
    <form noValidate action="" role="search">
      <input
        type="search"
        value={currentRefinement}
        onChange={(event) => refine(event.currentTarget.value)}
      />
      <button onClick={() => refine('')}>Reset query</button>
      {isSearchStalled ? 'My search is stalled' : ''}
    </form>
  )
}

export default SearchBox
